// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"cp-z","outfitFeedbackSection":"dp-z"};